import { CATEGORY_NAME, LIST_ACTIVITY } from "../api";
import axiosInstance from "../axiosInstance";

export const activelogcategoryname = (props) => (onResponse) => {
  try {
    let BASE_URL = CATEGORY_NAME + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.category_id) {
      BASE_URL += "category_id=" + props.category_id + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    axiosInstance
      .get(BASE_URL, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const activeloglist = (props) => (onResponse) => {
  console.log(props, "propssss");

  try {
    let BASE_URL = LIST_ACTIVITY + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.object_id) {
      BASE_URL += "object_id=" + props.object_id + "&";
    }
    axiosInstance
      .get(BASE_URL, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};
